import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "@mdi/font/css/materialdesignicons.css";

import "./App.css";
import "./styles/layout.css";
import config from "./config";

import Loader from "./utils/Loader";

import insta from "./assets/Footer/instaIng.webp";
import fbImg from "./assets/Footer/fbImg.png";
import tiktokImg from "./assets/Footer/tiktokImg.png";
import ytImg from "./assets/Footer/ytImg.png";

// Pages
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import MenuPage from "./pages/MenuPage";
import LocationPage from "./pages/LocationPage";
import FranchisePage from "./pages/FranchisePage";
import OurStoryPage from "./pages/OurStoryPage";
import ContactPage from "./pages/ContactPage";
import FullScreenMap from "./components/Map/FullScreenMap";
import FranchiseForm from "./components/Franchise/FranchiseForm";
import BlogsPage from "./pages/BlogsPage";
import BlogDetails from "./components/BlogPage/BlogDetails";
import LocationsPage from "./components/LocationPage/LocationsPage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import axios from "axios";
import NewMenuPage from "./pages/NewMenuPage";
import ErrorPage from "./components/ErrorPage";
import Footer from "./components/Footer";
// const homeRoutes = [
//   `${config.appUrl}/ajax`,
//   `${config.appUrl}/mississauga`,
//   `${config.appUrl}/scarborough`,
//   `${config.appUrl}/collingwood`,
//   `${config.appUrl}/regina`,
//   `${config.appUrl}/edmonton`,
//   `${config.appUrl}/guelph`,
//   `${config.appUrl}/vaughan`,
//   `${config.appUrl}/windsor`,
//   `${config.appUrl}/kitchener`,
//   `${config.appUrl}/brantford`,
//   `${config.appUrl}/calgary`,
//   `${config.appUrl}/north-park-drive-brampton`,
//   `${config.appUrl}/peterborough`,
//   `${config.appUrl}/halifax`,
//   `${config.appUrl}/waterloo`,
//   `${config.appUrl}/lebovic-scarborough`,
//   `${config.appUrl}/meadows`,
//   `${config.appUrl}/kingston`,
// ];

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const [showUpArrow, setShowUpArrow] = useState(false);
  const [allLocationsData, setAllLocationsData] = useState([]);

  const [call, setCall] = useState(false);
  const [location_name, setLocationName] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [testimonialsList, setTestimonialsList] = useState([]);
  const [locationArray, setLocationArray] = useState([]);

  const homeRoutes = locationArray?.length
    ? locationArray?.map((location) => `${config.appUrl}`)
    : [`${config.appUrl}`];

  // console.log("locationArray", locationArray)

  window.addEventListener("scroll", () => {
    if (window.scrollY >= 300) {
      setShowUpArrow(true);
    } else {
      setShowUpArrow(false);
    }
  });


  //=============================== Getting Users Location //===============================

  const [currentLocation, setCurrentLocation] = useState();
  const APIkey = process.env.REACT_APP_API_KEY;

  // checking browser has access to geolocation or not
  
useEffect(() => {
  // alert("wshiwhde")
  getUserLocation();
}, [])

  const getUserLocation = async () => {
    if (navigator.geolocation) {
      try {
        const permission = await navigator.permissions.query({
          name: "geolocation",
        });

        if (permission.state === "granted" || permission.state === "prompt") {
          navigator.geolocation.getCurrentPosition(success, errors, options);
        } else if (permission.state === "denied") {
          alert("Location Permission needed");
          handleLocationDenied();
        }
      } catch (error) {
        console.error("Permission check failed:", error);
        handleLocationDenied();
      }
    } else {
      console.log("Geolocation is not supported by this browser.");
      handleLocationDenied();
    }
  };

  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  function success(pos) {
    const { latitude, longitude } = pos.coords;
    getLocationInfo(latitude, longitude);
  }

  function errors(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
    alert("Kindly Enable Location Permission!");
    handleLocationDenied();
  }


  async function getLocationInfo(latitude, longitude) {
    try {
      const url = `https://api.opencagedata.com/geocode/v1/json?q=${latitude},${longitude}&key=${APIkey}`;
      const response = await fetch(url);
      const data = await response.json();

      if (data.status.code === 200 && data.results.length > 0) {
        const city_name =
          data.results[0]?.components?.state_district || "Unknown";
        setCurrentLocation(city_name);

        const tempLoc = allLocationsData.find((c) =>
          c?.location_name?.toLowerCase()?.includes(city_name?.toLowerCase())
        );

        if (tempLoc?.location_name) {
          localStorage.setItem("city_name", tempLoc?.location_name);
          localStorage.setItem("location", tempLoc?.id);
        } else {
          handleLocationDenied();
        }

        // Send location to backend
        const formData = new FormData();
        formData.append("location_name", city_name);

        await axios.post(`${config.apiUrl}/location_ip`, formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        });

        fetchData(); // ✅ Ensure all functions are called
      } else {
        console.log("Reverse geolocation request failed.");
        alert("Please Allow Location Access!");
        handleLocationDenied();
      }
    } catch (error) {
      console.error("Error fetching location:", error);
      handleLocationDenied();
    }
  }

  // ✅ Handle Denied Location Access
  function handleLocationDenied() {
    if (!localStorage.getItem("location_name"))
      localStorage.setItem("location_name", "Ajax");

    if (!localStorage.getItem("location")) 
    localStorage.setItem("location", 1);

    setCurrentLocation("Ajax");
    fetchData();
  }

  function fetchData() {
    fetchHomeData();
    getAllLinks();
    onMenuCategory();
    fetchTetimonials();
    setIsLoading(false);
  }

  useEffect(() => {
    onMenuCategory();
    fetchHomeData();
    fetchTetimonials();
    setIsLoading(false);
  }, [localStorage.getItem("location")]);

  //========================================================================================

  //✔ Getting Menu Category
  const onMenuCategory = async () => {
    // setIsLoading(true);
    const formData = new FormData();
    formData.append("location", localStorage.getItem("location"));
    // console.log("location send", localStorage.getItem("location"));
    try {
      const res = await axios({
        method: "post",
        url: `${config.apiUrl}/product_category`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        // setIsLoading(false);

        setCategoryList(res.data.data);
        // console.log("product_category", res.data.data);
      });
    } catch (error) {
      // setIsLoading(false);
      console.log("product category", error);
    }
  };

  //✔ Getting Testimonils List
  const fetchTetimonials = async () => {
    // setIsLoading(true);
    const formData = new FormData();
    formData.append("location", localStorage.getItem("location"));
    try {
      const res = await axios({
        method: "post",
        url: `${config.apiUrl}/reviews`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        // setIsLoading(false);
        setTestimonialsList(res.data.data);
        // console.log("Testimonills list", res.data.data)
      });
    } catch (error) {
      // setIsLoading(false);
      console.log("Testimonills List", error);
    }
  };

  const [intsLink, setInstaLink] = useState("");
  const [fbLink, setFbLink] = useState("");
  const [tiktokLink, setTiktokLink] = useState("");
  const [ytLink, setYtLink] = useState("");

  // ✔ Get All Locations links
  const getAllLinks = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${config.apiUrl}/locations`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setAllLocationsData(res.data.data);
        setInstaLink(res.data.data?.instagram_link);
        setFbLink(res.data.data?.facebook_link);
        setTiktokLink(res.data.data?.tiktok_link);
        setYtLink(res.data.data?.youtube_link);

        const locationName = res.data.data.map(
          (location) => location.location_name
        );
        // console.log("lcoationsName", res.data.data);
        setLocationArray(locationName);

        // console.log("All locations data",res.data.data);
      });
    } catch (error) {
      // setIsLoading(false);
      console.log("locations", error);
    }
  };

  // console.log("Location Array", locationArray);
  const [targetedLocation, setTargetedLocation] = useState("");
  // geting target location from homepage
  const getTargetLocation = (location) => {
    setTargetedLocation(location);
  };

  // footer
  const [footer_title, setFooterTitle] = useState("");
  const [footer_description, setFooterDesc] = useState("");
  const [footer_left_image, setFooterLeftImg] = useState("");
  const [footer_right_image, setFooterRightImg] = useState("");

  // Fetting Data
  const fetchHomeData = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("location", localStorage.getItem("location"));
    try {
      const response = await axios({
        method: "post",
        url: `${config.apiUrl}/home-data`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setIsLoading(false);
        // console.log("res",res)
        setFooterTitle(res.data.data.footer_title || "-");
        setFooterDesc(res.data.data.footer_description || "-");
        setFooterLeftImg(res.data.data.footer_left_image || "-");
        setFooterRightImg(res.data.data.footer_right_image || "-");
      });
    } catch (error) {
      setIsLoading(false);
      console.log("Home Page Data error", error);
    }
  };

  return (
    <>
      {isLoading && <Loader />}

      <div className="App">
        <Router>
          <Navbar
            call={call}
            locationArray={locationArray}
            categoryList={categoryList}
            setLocationName={setLocationName}
            targetedLocation={targetedLocation}
          />
          <Routes>
            {/* <Route exact path={`${config.appUrl}/`} Component={HomePage} /> */}
            <Route
              path={`${config.appUrl}/`}
              element={
                <HomePage
                  call={call}
                  setLocationName={setLocationName}
                  location_name={location_name}
                  categoryList={categoryList}
                  testimonialsList={testimonialsList}
                  locationArray={locationArray}
                />
              }
            />
            <Route path="*" element={<ErrorPage />} />

            {homeRoutes.map((route) => {
              return (
                <Route
                  key={route}
                  path={route}
                  element={
                    <HomePage
                      call={call}
                      setLocationName={setLocationName}
                      location_name={location_name}
                      categoryList={categoryList}
                      testimonialsList={testimonialsList}
                      intsLink={intsLink}
                      fbLink={fbLink}
                      tiktokLink={tiktokLink}
                      ytLink={ytLink}
                      locationArray={locationArray}
                      getTargetLocation={getTargetLocation}
                    />
                  }
                />
              );
            })}

            {/* <Route exact path={`${config.appUrl}franchise-form`} element={<FranchiseForm />} /> */}

            {/* Menu Paths  */}
            <Route
              exact
              path={`${config.appUrl}/menu`}
              // Component={MenuPage}
              element={<MenuPage categoryList={categoryList}> </MenuPage>}
            />
            {categoryList.map((menu_item) => {
              return (
                <Route
                  key={menu_item.slug}
                  path={`${config.appUrl}/:storedLocation/:category_name`}
                  element={<NewMenuPage categoryList={categoryList} />}
                />
              );
            })}

            {/* <Route exact path={`/rolled-ice-cream`} Component={MenuPage} /> */}

            {/* <Route exact path={`${config.appUrl}location`} Component={LocationPage} /> */}
            <Route
              exact
              path={`${config.appUrl}/:location_slug`}
              element={
                <LocationsPage
                  testimonialsList={testimonialsList}
                  categoryList={categoryList}
                >
                  {" "}
                </LocationsPage>
              }
            />
            <Route
              exact
              path={`${config.appUrl}/franchise`}
              Component={FranchisePage}
            />
            <Route
              exact
              path={`${config.appUrl}/franchise-form`}
              element={<FranchiseForm></FranchiseForm>}
            />
            <Route exact path={`${config.appUrl}/blog`} Component={BlogsPage} />

            {categoryList.map((menu_item) => {
              return (
                <Route
                  key={menu_item.slug}
                  path={`${config.appUrl}/blog-details/:slug`}
                  element={<BlogDetails categoryList={categoryList} />}
                />
              );
            })}

            <Route
              exact
              path={`${config.appUrl}/our-story`}
              Component={OurStoryPage}
            />
            <Route
              exact
              path={`${config.appUrl}/contact-us`}
              element={<ContactPage allLocationsData={allLocationsData} />}
            />
            <Route
              exact
              path={`${config.appUrl}/fullscreenMap`}
              Component={FullScreenMap}
            />
            <Route
              exact
              path={`${config.appUrl}/privacy-policy`}
              Component={PrivacyPolicy}
            />
          </Routes>
          <Footer
            footer_title={footer_title}
            footer_description={footer_description}
            footer_left_image={footer_left_image}
            footer_right_image={footer_right_image}
            intsLink={intsLink}
            fbLink={fbLink}
            tiktokLink={tiktokLink}
            ytLink={ytLink}
          />
        </Router>
      </div>

      {/* Social_links  */}
      <div className="float-container">
        <a
          href={intsLink || "https://www.instagram.com/rollzicecreams/"}
          target="_blank"
          className="social-link"
        >
          <img src={insta} alt="Instagram" className="img-fluid" />
          <span>Instagram</span>
        </a>

        <a
          href={fbLink || "https://www.facebook.com/rollzicecream"}
          target="_blank"
          className="social-link"
        >
          <img src={fbImg} alt="Facebook" className="img-fluid" />
          <span>Facebook</span>
        </a>

        <a
          href={tiktokLink || "https://www.tiktok.com/@rollzicecream"}
          target="_blank"
          className="social-link"
        >
          <img src={tiktokImg} alt="TikTok" className="img-fluid" />
          <span>TikTok</span>
        </a>

        <a
          href={ytLink || "https://www.youtube.com/@rollzicecream"}
          target="_blank"
          className="social-link"
        >
          <img src={ytImg} alt="YouTube" className="img-fluid" />
          <span>YouTube</span>
        </a>
      </div>

      {/* Up Arrow Btn  */}
      <div
        className={`scroll_up ${showUpArrow ? "d-block" : "d-none"}`}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        title="Scroll Up"
      >
        {/* <img src={UpArrow} alt='Up Arrow' className='img-fluid' /> */}
        <i className="bi bi-arrow-up"></i>
      </div>

      
    </>
  );
}

export default App;
